import { LoggerContract } from "../../contracts/logger/logger";

function niceConsole(...args: any[]) {
  console.log.apply(undefined, ["%c%s", "color:blue", ...args]);
}
const ConsoleLogger: LoggerContract = {
  setup: () => {
    niceConsole("Logger setup");
  },
  identify(identifier: any) {},
  Error(error: any, context?: any) {
    const message = error.stack ? error.stack : error;
    niceConsole(message, context);
  },
};

export default ConsoleLogger;
